<template>
  <div>
    <div class="card  ">
      <div class="card-content ">
        <span class="card-title">
          Invoices vs PO

          <el-select
            v-model="selected_branches"
            size="small"
            multiple
            collapse-tags
            style="margin-left: 10px;"
            placeholder="Select branch(es)"
            @change="fill_data"
          >
            <el-option
              v-for="branch in branches_list"
              :key="branch.id"
              :label="branch.name"
              :value="branch.id"
            />
          </el-select>
        </span>
 
        <el-date-picker
          v-model="selected_date_range"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          style="width: auto !important;"
          :picker-options="pickerOptions2"
          @change="fill_data"
        />
        <br>
        <br>
        <table>
          <tr class="header">
            <th>INVOICES</th>
            <th>COST</th>
            <th>PROFIT</th>
          </tr>
          <tr class="rows">
            <td>
              <span class="center">{{ total_invoices | currency }}</span>
            </td>
            <td>
              <span class="center">{{ total_cost | currency }}</span>
            </td>
            <td>
              <span class="center">{{ gross_profit | currency }}</span>
            </td>
          </tr>
        </table>

        <pie-chart
          :chart-data="datacollection"
          :options="chartOptions"
        />
      </div>
      <div class="card-action">
        <button
          class="btn btn-small"
          @click="show_invoices_list"
        >
          Invoices details
        </button>
        <button
          class="btn btn-small right"
          @click="show_cost_list"
        >
          Cost details
        </button>
      </div>
    </div>
    <modal
      name="invoices_records_list"
      :height="700"
      :width="1200"
      :adaptive="true"
    >
      <div class="card ">
        <div class="card-content  ">
          <span
            class="card-title"
          >{{ list_title }}
            <hr></span>
          <div
            v-show="is_loading"
            class="progress"
          >
            <div class="indeterminate" />
          </div>
          <el-table
            :data="rows"
            style="width: 100%"
            height="600"
          >
            <el-table-column
              v-for="column in columns"
              :key="column"
              :prop="column"
              :label="column | capitalize"
              sortable
            />
          </el-table>
        </div>
        <div class="card-action" />
      </div>
    </modal>
  </div>
</template>
<script>
import PieChart from './PieChart';
export default {
  name: 'InvoicesDashboard',
  components: {
    PieChart
  },
  data() {
    return {
      datacollection: {},
      branches_list: [],
      selected_branches: [],
      total_invoices: 0,
      total_cost: 0,
      columns: [],
      rows: [],
      list_title: '',
      is_loading: false,
      pickerOptions2: {
        shortcuts: [
          {
            text: 'Current month',
            onClick(picker) {
              const end = new Date();
              const start = new Date(
                new Date().getFullYear(), 
                new Date().getMonth(),
                1
              );
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last 6 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last year',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      selected_date_range: ''
    };
  },
  computed: {
    current_date() {
      return new Date();
    },
    start_date() {
      return new Date(
        this.current_date.getFullYear(),
        this.current_date.getMonth(),
        1
      );
    },
    end_date() {
      return new Date(
        this.current_date.getFullYear(),
        this.current_date.getMonth(),
        this.current_date.getDate()
      );
    },
    gross_profit() {
      return this.total_invoices - this.total_cost;
    }
  },
  mounted() {
    this.load_branches_list();
    this.selected_date_range = [this.start_date, this.end_date];
  },
  created() {},
  methods: {
    load_branches_list() {
      let self = this;
      self.is_loading = true;
      this.$http.get('/branches_list').then(response => {
        this.branches_list = response.data;
        this.selected_branches = this.branches_list.map(c => c.id);
        this.fill_data();
        self.is_loading = false;
      });
    },
    fill_data() {
      this.$http
        .post('/get_invoices_info', {
          start_date: this.selected_date_range[0],
          end_date: this.selected_date_range[1],
          branches_ids: this.selected_branches
        })
        .then(response => {
          if (response.data.status == 200) {
            this.total_invoices = response.data.data.total_invoices;
            this.total_cost = response.data.data.total_cost;

            let categorized_invoices = response.data.data.categorized_invoices;
            let categorized_cost = response.data.data.categorized_cost;
            let bg_colors = Array(categorized_invoices.total.length)
              .fill('lightgreen')
              .concat(Array(categorized_cost.total.length).fill('#f38686'));

            this.datacollection = {
              // labels: ['Profit', 'Cost'],
              labels: categorized_invoices.categories_names.concat(
                categorized_cost.categories_names
              ),
              datasets: [
                {
                  label: 'Invoices',
                  backgroundColor: bg_colors,
                  data: categorized_invoices.total.concat(
                    categorized_cost.total
                  )
                }
              ]
            };
          }
        });
    },
    show_invoices_list() {
      this.open_modal();
      this.columns = [];
      this.rows = [];
      this.list_title = 'Invoices list items';
      this.is_loading = true;
      this.$http
        .post('/get_invoices_records', {
          start_date: this.selected_date_range[0],
          end_date: this.selected_date_range[1],
          branches_ids: this.selected_branches
        })
        .then(response => {
          this.is_loading = false;
          if (response.data.status == 200) {
            this.columns = response.data.data.columns;
            this.rows = response.data.data.rows;
          }
        });
    },
    show_cost_list() {
      this.open_modal();
      this.columns = [];
      this.rows = [];
      this.list_title = 'PO list items';
      this.is_loading = true;
      this.$http
        .post('/get_po_records', {
          start_date: this.selected_date_range[0],
          end_date: this.selected_date_range[1],
          branches_ids: this.selected_branches
        })
        .then(response => {
          this.is_loading = false;
          if (response.data.status == 200) {
            this.columns = response.data.data.columns;
            this.rows = response.data.data.rows;
          }
        });
    },
    open_modal() {
      this.$modal.show('invoices_records_list');
    },
    hide_modal() {
      this.$modal.hide('invoices_records_list');
    },
    chartOptions: function() {
      return { responsive: true, maintainAspectRatio: false };
    }
  }
};
</script>

<style scoped>
td,
th {
  text-align: center;
  padding: 10px;
}

th {
  font-weight: 800;
}
.header {
  background-color: #ddecf9;
}
.subheader {
  background-color: #e5f3ff;
}
.rows {
  background-color: aliceblue;
}
</style>
